import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

import { SlackReminderFieldsFragment } from '../common';

export type SlackReminder = {
  id: number;
  message: string;
  title: string;
  datetime: string;
  notifyStatus: number;
  selectedGuestStatuses: number[];
  schedule: {
    quantity: number;
    unit: string;
    beforeEventBegins: boolean;
  };
};

/**
 * Upsert can have id optional.
 */
type UpsertSlackReminderResult = {
  ok: boolean;
  slackReminder: SlackReminder;
};

export interface UpsertSlackReminderInput extends Pick<SlackReminder, 'message' | 'title'> {
  id?: number;
  eventId: number;
  datetime?: string;
  schedule?: {
    quantity?: number;
    unit?: string;
    beforeEventBegins?: boolean;
  };
  selectedGuestStatuses?: string[];
}

const UpsertSlackReminderMutation = gql`
  mutation UpsertEventSlackReminder($input: SlackReminderInput!) {
    upsertEventSlackReminder(input: $input) {
      ok
      slackReminder {
        ...SlackReminderFieldsFragment
      }
    }
  }
  ${SlackReminderFieldsFragment}
`;

export interface DeleteSlackReminderInput {
  id: number;
  eventId: number;
}

type DeleteSlackReminderResult = {
  ok: boolean;
};

const DeleteSlackReminderMutation = gql`
  mutation DeleteEventSlackReminder($input: DeleteEventReminderInput!) {
    deleteEventSlackReminder(input: $input) {
      ok
    }
  }
`;

export const slackRemindersApi = {
  upsert: ({ input }: { input: UpsertSlackReminderInput }): Promise<UpsertSlackReminderResult> => {
    return gqlClient
      .request<{ upsertEventSlackReminder: UpsertSlackReminderResult }>(
        UpsertSlackReminderMutation,
        {
          input
        }
      )
      .then((res) => res.upsertEventSlackReminder);
  },
  delete: ({ input }: { input: DeleteSlackReminderInput }): Promise<DeleteSlackReminderResult> => {
    return gqlClient
      .request<{ deleteEventSlackReminder: DeleteSlackReminderResult }>(
        DeleteSlackReminderMutation,
        { input }
      )
      .then((res) => res.deleteEventSlackReminder);
  }
};
